// Backwards-compatible wrappers around the canonical helpers in time.js.
// The bug fixed here: server timestamps are naive UTC (no Z, no offset).
// Plain `new Date(value)` parses them as local time, so a 5-minute-old
// timestamp shows as "2 hours ago" for an America/New_York browser.
import { parseServerDate, formatRelativeTime as _formatRelativeTime } from './time';

export const formatDate = (dateValue, fallback = 'N/A') => {
  if (!dateValue) return fallback;
  const d = parseServerDate(dateValue);
  if (!d || isNaN(d.getTime())) return fallback;
  return d.toLocaleString();
};

export const formatRelativeTime = (dateValue) => {
  if (!dateValue) return 'N/A';
  const d = parseServerDate(dateValue);
  if (!d || isNaN(d.getTime())) return 'N/A';
  const diffSecs = Math.max(0, Math.floor((Date.now() - d.getTime()) / 1000));
  if (diffSecs < 60) return 'Just now';
  const diffMins = Math.floor(diffSecs / 60);
  if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  return d.toLocaleDateString();
};

export const formatScanDuration = (startDate, endDate = null) => {
  if (!startDate) return 'N/A';
  const start = parseServerDate(startDate);
  if (!start || isNaN(start.getTime())) return 'N/A';

  const end = endDate ? parseServerDate(endDate) : new Date();
  if (!end || isNaN(end.getTime())) return 'N/A';

  const diffMs = end.getTime() - start.getTime();
  if (diffMs < 0 || isNaN(diffMs)) return 'N/A';

  const diffSecs = Math.floor(diffMs / 1000);
  const secs = diffSecs % 60;
  const mins = Math.floor(diffSecs / 60) % 60;
  const hours = Math.floor(diffSecs / 3600);

  if (hours > 0) return `${hours}h ${mins}m`;
  if (mins > 0) return `${mins}m ${secs}s`;
  return `${secs}s`;
};

// Re-export the short-form helper from time.js so call sites that prefer
// the compact "5m ago" style get consistent UTC handling too.
export const formatRelativeTimeShort = _formatRelativeTime;
